/**
 * Frontend-каталог типів полів. Дзеркало backend
 * `apps/api/src/modules/data-tables/catalog.ts` — тримати в синхроні
 * (label/category можуть розходитись, бо backend їх не використовує —
 * лише key для валідації).
 *
 * Самі таблиці (built-in + custom) тепер віддає бекенд через
 * GET /api/admin/data-tables.
 */

export type FieldTypeKey =
  | 'single_line'
  | 'multi_line'
  | 'dropdown'
  | 'date'
  | 'datetime'
  | 'email'
  | 'number'
  | 'auto_number'
  | 'percent'
  | 'currency'
  | 'phone'
  | 'url'
  | 'country'
  | 'tags'
  | 'checkbox'
  | 'formula'
  | 'stat'
  | 'linked_record'
  | 'linked_summary';

export interface FieldType {
  key: FieldTypeKey;
  label: string;
  icon: string;
  category: 'common' | 'advanced';
}

export const FIELD_TYPES: FieldType[] = [
  { key: 'single_line', label: 'Однорядковий', icon: 'Tt', category: 'common' },
  { key: 'multi_line', label: 'Багаторядковий', icon: '☰', category: 'common' },
  { key: 'dropdown', label: 'Випадаюче меню', icon: '⌄', category: 'common' },
  { key: 'date', label: 'Дата', icon: '📅', category: 'common' },
  { key: 'datetime', label: 'Дата і час', icon: '🕒', category: 'common' },
  { key: 'email', label: 'Email', icon: '✉️', category: 'common' },
  { key: 'number', label: 'Число', icon: '123', category: 'common' },
  { key: 'auto_number', label: 'Автоматичне число', icon: '#₁', category: 'common' },
  { key: 'percent', label: 'Відсоток', icon: '%', category: 'common' },
  { key: 'currency', label: 'Валюта', icon: '$', category: 'common' },
  { key: 'phone', label: 'Телефон', icon: '📞', category: 'common' },
  { key: 'url', label: 'URL', icon: '🌐', category: 'common' },
  { key: 'country', label: 'Країна', icon: '🏳️', category: 'common' },
  { key: 'tags', label: 'Теги', icon: '🏷️', category: 'common' },
  { key: 'checkbox', label: 'Чекбокс', icon: '☑', category: 'common' },
  { key: 'formula', label: 'Формула', icon: 'ƒx', category: 'advanced' },
  { key: 'stat', label: 'Статистика', icon: '📊', category: 'advanced' },
  { key: 'linked_record', label: "Пов'язані записи", icon: '↗', category: 'advanced' },
  { key: 'linked_summary', label: "Пов'язані підсумки", icon: 'Σ↗', category: 'advanced' },
];

export function fieldType(t: FieldTypeKey): FieldType {
  return FIELD_TYPES.find((ft) => ft.key === t) ?? FIELD_TYPES[0]!;
}
